export default __webpack_public_path__ + "static/media/maor-pledge-logo.75cb180e.png";